module.exports = __webpack_public_path__ + "img/avatar.84822bad.png";